let config = require('../data/config.json');

export class AppConfig {
  public static title = "OneClick Community";
  public static icon = "/favicon.png";
  public static logo = "/logo.png";
  public static mobile = null;
  public static private = false;

  public static theme = null;
  public static community = null;

  public static pages = config.pages;
  public static themes = config.themes;
  public static icons = config.icons;
  public static fonts = config.fonts;
  public static palettes = config.palettes;
  public static styles = config.styles;
  public static menu = config.menu.main;

  public static setCommunity(community:any) {
    AppConfig.community = community;
    AppConfig.title = community.name;
    AppConfig.theme = community.theme;
    AppConfig.mobile = community.mobile;
    AppConfig.menu = config.menu.community;

    AppConfig.logo = community.logo ? community.logo : '/logo-default.png';
    if (AppConfig.logo.indexOf('https://s3.us-west-2.amazonaws.com/oneclick.media') !== -1) 
      AppConfig.logo = AppConfig.logo.replace('https://s3.us-west-2.amazonaws.com/oneclick.media', 'https://d27jhqexqrz634.cloudfront.net');

    AppConfig.icon = community.icon;
    if (AppConfig.icon.indexOf('https://s3.us-west-2.amazonaws.com/oneclick.media') !== -1) 
      AppConfig.icon = AppConfig.icon.replace('https://s3.us-west-2.amazonaws.com/oneclick.media', 'https://d27jhqexqrz634.cloudfront.net');

    AppConfig.update();
  }

  public static update() {
    document.title = AppConfig.title;
    // AppConfig.updateFavicon(AppConfig.icon);
    if(AppConfig.theme) 
      AppConfig.applyTheme(AppConfig.theme.palette, AppConfig.theme.styles);
  }

  public static applyTheme(palette:string[], styles:any) {
    let font = styles['body-font'];

    if(font && AppConfig.fonts.indexOf(font) == -1) {
      let fontLink = document.getElementById('GoogleFontLink') as HTMLLinkElement;
      fontLink.href = `https://fonts.googleapis.com/css?family=${font}`;
    }

    let style = document.documentElement.style
    let properties = Object.keys(styles);
    for(let i = 0; i < properties.length; i++) {
      let value = styles[properties[i]];
      if(typeof value == 'number') {
        let color = palette[value];
        if(color == undefined) 
          value = 'black';
        else
          value = color;
      }
      style.setProperty('--' + properties[i], value);
    }

    let scale = styles['body-font-scale'];
    let newScale = +scale.substring(0, scale.length-1);
    newScale += 20;
    style.setProperty('--quill-font-scale', newScale + '%');
  }

  protected static updateFavicon(url: string) {
    let link: HTMLLinkElement | null = document.getElementById('dynamic-favicon') as HTMLLinkElement;
  
    if (!link) {
      link = document.createElement('link');
      link.id = 'dynamic-favicon';
      link.rel = 'icon';
      link.type = 'image/png'; // Use PNG for compatibility
      document.head.appendChild(link);
    }
  
    // Use a cache-busting timestamp
    link.href = url + '?v=' + new Date().getTime();   
  }
  
}
